<div class="wizard-core-selection">
    <edge-picker-inline [selectedEdgesIds]="selectedEdgeIds"
        [options]="{ selectedLocationId: locationId, checkCreateCameraPermission: true, multi: false }"
        (onSave)="onEdgeSelected($event)">
    </edge-picker-inline>
</div>